import { callAPI } from "../helper/apiUtils";
import { $crud } from "../helper/CrudFactory";
import { $user } from "../helper/UserFactory";
import {
  RESET_SOCKET,
  SET_AUTO_TRANSLATION,
  SET_AUTO_TRANSLATION_LANGUAGES,
  SET_TRANSLATE_ROOM_AND_GROUP_NAMES,
  SET_USER_LOGIN_TOKEN,
} from "../store";

/**
 * Log out, shared by the personal settings and the side nav (one cleanup for
 * both). As in the mobile app, logging out asks first.
 */

const isGermanUi = () => {
  try {
    return /^(de|gsw|wae)\b/i.test(localStorage.getItem("language") || "");
  } catch (_) {
    return false;
  }
};

/** Signs out: server session, local caches and Redux, then the start page. */
export async function logoutUser({ dispatch, history } = {}) {
  ["autoTrans", "autoTranslationLanguages", "translateRoomAndGroupNames", "videoCallPop"].forEach((key) => {
    try {
      localStorage.removeItem(key);
    } catch (_) {
      /* ignore */
    }
  });
  try {
    await callAPI("/user/logout", {}, "GET");
  } catch (_) {
    /* sign out locally anyway */
  }
  if (dispatch) dispatch({ type: RESET_SOCKET, payload: true });
  await $user.logout();
  if (dispatch) {
    // Auto translation is always on; the next login loads the user's own settings.
    dispatch({ type: SET_AUTO_TRANSLATION, status: true });
    dispatch({ type: SET_AUTO_TRANSLATION_LANGUAGES, languages: null });
    dispatch({ type: SET_TRANSLATE_ROOM_AND_GROUP_NAMES, status: false });
    dispatch({ type: SET_USER_LOGIN_TOKEN, status: null });
  }
  if (window.electron && typeof window.electron.sendBadgeUpdate === "function") {
    window.electron.sendBadgeUpdate("");
  }
  if (history) history.push("/");
}

/**
 * Asks "Abmelden / Zum Abmelden bestätigen", then signs out.
 * Resolves to true when the user was logged out, false when cancelled.
 */
export async function confirmAndLogout({ strings = {}, isGerm, dispatch, history } = {}) {
  const german = typeof isGerm === "boolean" ? isGerm : isGermanUi();
  try {
    await $crud.confirm({
      title: strings.logout || (german ? "Abmelden" : "Logout"),
      textContent: strings.confirm_logout || (german ? "Zum Abmelden bestätigen" : "Confirm to Logout"),
      options: {
        ok: strings.ok || "OK",
        cancel: strings.cancel || (german ? "Abbrechen" : "Cancel"),
      },
    });
  } catch (_) {
    return false;
  }
  await logoutUser({ dispatch, history });
  return true;
}
